// src/features/idealWeek/services/idealWeekService.ts

import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { logger } from '../../../utils/logger';
import { IdealWeek } from '../types/idealWeek';

export const updateUserIdealWeek = async (
  userId: string,
  idealWeekData: IdealWeek
): Promise<boolean> => {
  try {
    const userDocRef = doc(db, 'users', userId);
    await updateDoc(userDocRef, { idealWeek: idealWeekData, updatedAt: new Date() });
    return true;
  } catch (error) {
    logger.error('IdealWeek 更新用戶 Ideal Week 設定失敗', error);
    throw error;
  }
};
